import React from 'react';
import { GlobalOutlined, MailOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useLanguage } from '../components/language/LanguageContext';
import styles from './LandingNavbar.module.scss';

const LandingNavbar: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();

  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleLanguage = () => {
    const currentLang = language as string;
    if (currentLang === 'en' || currentLang === 'zh-CN') {
      setLanguage(currentLang === 'en' ? 'zh-CN' : 'en');
    }
  };

  const getCurrentLanguage = () => {
    const currentLang = language as string;
    return currentLang === 'zh-CN' || currentLang === 'cn' ? 'cn' : 'en';
  };

  const displayLanguage = getCurrentLanguage();

  return (
    <nav className={styles.navbar}>
      <div className={styles.logoContainer}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}></div>
          <span className={styles.logoText}>RB Translator</span>
        </div>
      </div>

      <div className={styles.navItems}>
        <a
          href="https://www.roundblock.io/"
          className={styles.companyLink}
        >
          {t('landing.navbar.company')}
        </a>

        <a
          href="#contact-section"
          onClick={scrollToContact}
          className={styles.contactLink}
        >
          <MailOutlined className={styles.icon} />
          {t('landing.navbar.contactSales')}
        </a>

        <button
          onClick={toggleLanguage}
          className={styles.languageSwitcher}
        >
          <GlobalOutlined className={styles.icon} />
          <span className={displayLanguage === 'en' ? styles.activeLang : ''}>EN</span>
          <span className={styles.separator}>/</span>
          <span className={displayLanguage === 'cn' ? styles.activeLang : ''}>中文</span>
        </button>

        <a
          href="/app"
          className={styles.tryButton}
        >
          {t('landing.navbar.tryTranslator')} <ArrowRightOutlined className={styles.smallIcon} />
        </a>
      </div>
    </nav>
  );
};

export default LandingNavbar;
